import { UpsellContent } from './UpsellContent';

export enum UpsellsContentType {
  LEGACY = 'LEGACY',
  NATIVE = 'NATIVE',
}

export const legacyUpsellContentKeys: Record<string, string> = {
  ultraPack: 'ULTRA_PACK',
  numerologyAnalysis: 'NUMEROLOGY_ANALYSIS',
  tarotReading: 'TAROT_READING',
  palmistryGuide: 'PALMISTRY_GUIDE',
};

type UpsellPrices = Pick<UpsellContent, 'price' | 'oldPrice'>;

type UpsellCardEntry = [string, UpsellPrices];

const hasCard = (entry: [string, UpsellPrices | undefined]): entry is UpsellCardEntry => !!entry[1];

const isNativeCard = ([key, card]: UpsellCardEntry) =>
  !(key in legacyUpsellContentKeys) && !!card.price && !!card.oldPrice;

export const getUpsellsContentType = (
  content: Record<string, UpsellPrices | undefined> | undefined,
): UpsellsContentType => {
  const cards = Object.entries(content ?? {}).filter(hasCard);

  if (!cards.length) {
    return UpsellsContentType.LEGACY;
  }

  const isNative = cards.every(isNativeCard);

  return isNative ? UpsellsContentType.NATIVE : UpsellsContentType.LEGACY;
};
